import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StepsDataService } from '../../shared/_services/steps-data.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemeService } from '../../shared/_services/theme.service';
import { StepsHeaderComponent } from '../components/steps-header/steps-header.component';
import { ChangeLanguageComponent } from '../components/change-language/change-language.component';

@Component({
	selector: 'app-pagina-errore',
	imports: [TranslatePipe, StepsHeaderComponent, ChangeLanguageComponent],
	templateUrl: './pagina-errore.component.html',
	styles: ``,
})
export class PaginaErroreComponent {
	isPagamentoAnnullato: boolean = false;
	hasOrdine: boolean = false; //controlla che ci sia effettivamente un ordine da pagare
	is404: boolean = false;
	errorImageUrl: string = '';
	isImatra = false;

	constructor(private router: Router, private dataService: StepsDataService, private readonly themeService: ThemeService) {
		this.isImatra = this.themeService.getTenantId() === 1;
	}

	ngOnInit(): void {
		this.isPagamentoAnnullato = this.router.url.includes('/step-pagamento-annullato');
		this.is404 = this.router.url.includes("404");
		const quoteId = JSON.parse(sessionStorage.getItem('quoteId') as string);
		const customerId = this.dataService.getCustomer(false)?.customerId ?? null;
		this.hasOrdine = quoteId && customerId;
		this.errorImageUrl = this.themeService.getErrorImage();
	}

	
	tornaIndietro(home: boolean) {
		if (home) {
			this.router.navigate([this.themeService.getLandingUrl()]);
		} else {
			this.router.navigate(['/steps-preventivo/step-tre']);
		}
	}
}
